const mainboardSteps = [
    {
        selector: '#revenue',
        content: 'Xem lại doanh thu hàng tháng',
    },
    {
        selector: '#notify',
        content: 'Xem lại các thông báo mới nhất',
    },
    {
        selector: '#task',
        content: 'Xem lại các công việc mới nhất',
    },
    {
        selector: '#business',
        content: 'Xem lại các dự án mới nhất',
    },
    {
        selector: '#work-days',
        content: 'Xem lại các ngày nghỉ lễ',
    },
    {
        selector: '#events',
        content: 'Xem lại các sự kiện sắp tới',
    },
]

export default mainboardSteps
